import { BASE_URL } from "./constants";

const checkResponse = (res) => {
  if (res.ok) {
    return res.status === 204 ? { success: 'ok' } : res.json();
  } else {
    return res.json().then((err) => Promise.reject(err));
  }
}

export const getCategoriesRequest = () => {
  return fetch(`${BASE_URL}/api/categories/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getProducts = () => {
  return fetch(`${BASE_URL}/api/products/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}
